import { render } from "./App.vue?vue&type=template&id=61961fc1"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./macrofox.css?vue&type=style&index=0&lang=css"
import "./macrofox.app.css?vue&type=style&index=1&lang=css"
import "./macrofox.icons.css?vue&type=style&index=2&lang=css"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__